import { render, staticRenderFns } from "./ListTwoAdd.vue?vue&type=template&id=024cfb80&scoped=true"
import script from "./ListTwoAdd.vue?vue&type=script&lang=js"
export * from "./ListTwoAdd.vue?vue&type=script&lang=js"
import style0 from "./ListTwoAdd.vue?vue&type=style&index=0&id=024cfb80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024cfb80",
  null
  
)

export default component.exports